export enum Level {
  Simple = 'simple',
  Medium = 'medium',
  Hard = 'hard',
}
